var map = {
	"./new-empty.svg": 5864,
	"./new-flow.svg": 94645,
	"./new-gantt.svg": 90705,
	"./new-org.svg": 98197,
	"./new-plan.svg": 59108,
	"./new-uml.svg": 82425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97037;